import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import { isAnalyticsDateSelectable } from '@/common/utils/analytics_period'

interface Props {
  value?: (string | Date)[] | null
  campaignStartDatetime?: string | Date | null
  campaignEndDatetime?: string | Date | null
}

type PickedRange = {
  minDate: Date | null
  maxDate: Date | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticsPeriodPicker',
  props: {
    value: null,
    campaignStartDatetime: null,
    campaignEndDatetime: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: Date[] | null): void
  (e: 'change', value: Date[] | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: (string | Date)[] | null
  campaignStartDatetime?: string | Date | null
  campaignEndDatetime?: string | Date | null
};




const pickedDate = ref<Date | null>(null)

const isDisabledDate = (date: Date) => {
  // ダイアログはキャンペーン取得前と閉じた後も描画されたままのため
  if (!props.campaignStartDatetime || !props.campaignEndDatetime) {
    return false
  }

  const isSelectable = isAnalyticsDateSelectable(
    date,
    props.campaignStartDatetime,
    props.campaignEndDatetime,
    pickedDate.value
  )

  return !isSelectable
}

const handlePick = ({ minDate, maxDate }: PickedRange) => {
  const isOneSidePicked = !maxDate

  if (isOneSidePicked) {
    pickedDate.value = minDate
    return
  }

  pickedDate.value = null
}

const pickerOptions = {
  disabledDate: isDisabledDate,
  onPick: handlePick
}

const handleInput = (value: Date[] | null) => emit('input', value)
const handleChange = (value: Date[] | null) => emit('change', value)

// 片側だけ選んで閉じたとき、次に開いた際に古い選択で日付が選べなくならないようにするため
const resetPickedDate = () => {
  pickedDate.value = null
}

return { __sfc: true,props, emit, pickedDate, isDisabledDate, handlePick, pickerOptions, handleInput, handleChange, resetPickedDate }
}

})